/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_TitleInputs */



/**
* | output |
* | --- |
* | "Editor Settings" |
*
* @param {Options_Editor_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_title = /** @type {((inputs?: Options_Editor_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de l'éditeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Editor-Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni dell'editor")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки редактора")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración del editor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑器设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エディター設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादक सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações do editor")
	return /** @type {LocalizedString} */ ("Editor Settings")
});